//@ts-nocheck directive
import React, { useState, useEffect } from "react";
import { UpdateUserProfileType } from "../Types/userProfile";
import styles from "./Connection.module.css";

import "../lib/RequireUser/index.css";
import { useNavigate } from "react-router-dom";
import { getDatabase, ref, set } from "firebase/database";
import { auth, app } from "../lib/firebase";
import {
  DocumentData,
  QueryDocumentSnapshot,
  QuerySnapshot,
  collection,
  getDocs,
  orderBy,
  doc,
  deleteDoc,
  getFirestore,
  onSnapshot,
  query,
  where,
  updateDoc,
  arrayUnion,
} from "firebase/firestore";
import CreatePhotoURL from "./CreatePhotoURL";
import UpdateUserPhotoURL from "../UserProfile/UpdateUserPhotoURL";
import WelcomePage from "../WelcomePage/WelcomePage";
import { useAuthState } from "react-firebase-hooks/auth";
import { updateProfile } from "firebase/auth";
import UpdateUserProfileName from "../UserProfile/UpdateUserProfileName";
import photoURL from "../../Images/photoURL.png";
import Upload from "../Cloud/Upload";

interface IProps {
  userProfile: UpdateUserProfileType;
}

const storageName = "https://storage.googleapis.com/";

const bucketName = "footprints-b291f.appspot.com/";

const db = getFirestore(app);

//gs://footprints-b291f.appspot.com/Fred3.jpg
//const fullURL = storageName + bucketName + photoName;
const tempUser = localStorage.getItem("userUID");

function ToMeRequestsPost({ userProfile }: IProps) {
  const [connectionsRefArray, SetConnectionsRefArray] = useState([]);
  //let connectionsRefArray: string[] = [];
  const [userAbout, setUserAbout] = useState(userProfile.userAbout);
  const [userFirstName, setUserFirstName] = useState(userProfile.userFirstName);
  const [userLastName, setUserLastName] = useState(userProfile.userLastName);

  const [thisUserProfile, setThisUserProfile] = useState<NewUserProfileType[]>(
    []
  );

  const [userConnectionsRefArray, setUserConnectionsRefArray] = useState<
    NewUserProfileType[]
  >([]);

  const [userProfileLink1, setUserProfileLink1] = useState(
    userProfile.userProfileLink1
  );
  const [userProfileLink2, setUserProfileLink2] = useState(
    userProfile.userProfileLink2
  );
  const [userProfileLink3, setUserProfileLink3] = useState(
    userProfile.userProfileLink3
  );
  const [userProfileLink4, setUserProfileLink4] = useState(
    userProfile.userProfileLink4
  );

  const [userPhotoName, setUserPhotoName] = useState(
    storageName + bucketName + userProfile.userPhotoName
  );
  const [userProfileName, setUserProfileName] = useState(
    userProfile.userProfileName
  );
  const [userCountry, setUserCountry] = useState(userProfile.userCountry);
  const [userEmail, setUserEmail] = useState(userProfile.userEmail);

  const [selectedFile, setSelectedFile] = useState<File | null>(null); // Add state for the selected file

  const [connectionRequestsAll, setConnectionRequestsAll] = useState<
    ConnectionRequestPost[]
  >([]);

  let requestFromEmail = "";
  let requestToEmail = "";
  //query all userProfile and output only this user
  const qUser = query(
    collection(db, "userProfiles"),
    where("userUID", "==", tempUser)
  );

  //load only this user's profile
  useEffect(
    () =>
      onSnapshot(qUser, (snapshot) => {
        setThisUserProfile(
          snapshot.docs.map((doc) => {
            if (doc.id) {
              console.log(
                " toMe got a doc id from onSnapshot for thisUserProfile "
              );
              userConnectionsRefArray.push(doc.id);
              console.log(
                " userConnectionsRefArray [0] ",
                userConnectionsRefArray[0]
              );
              console.log(" doc data () ", doc.data());
            }
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );

  if (thisUserProfile.length != 0) {
    requestToEmail = thisUserProfile[0].userEmail;
    console.log("requestToEmail = ", requestToEmail);
  }

  //Query all connectionRequests
  const qConnectionRequests = query(
    collection(db, "connectionRequests")
    //where("requestToEmail", "==", thisUserProfile[0].userEmail),
    //orderBy("userProfileName", "desc")
  );
  //Load all connection requests and load the references for each doc in case we need to delete
  //this connection document
  //connectionsRefArray = [];
  useEffect(
    () =>
      onSnapshot(qConnectionRequests, (snapshot) => {
        setConnectionRequestsAll(
          snapshot.docs.map((doc) => {
            if (doc.id) {
              console.log(
                " toMe got a doc id from onSnapshot for connectionRequests "
              );
              connectionsRefArray.push(doc.id);
              console.log(" connectionsRefArray [0] ", connectionsRefArray[0]);
              console.log(" doc data () ", doc.data());
            }

            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );

  console.log("connectionsRefArray[0] = ", connectionsRefArray[0]);

  function getSelect(e: ChangeEvent<HTMLSelectElement>) {
    console.log("selectedValue = ", e);
    //const temp = e.currentTarget.selectedIndex;
    let temp = e;

    setUserCountry(temp);
    console.log("temp value for country = ", temp);
  }
  function reloadFromError() {
    window.location.reload();
  }

  async function acceptButtonFunction(userEmail) {
    console.log("in accept button function");
    //Two things to do
    //First: add the accepted user's email to the usrConnections arry in thisUser's profile
    // "your_collection = "userProfiles"
    // "your_document_id" = userConnectionsRefArray[0]
    //  new_item_1 = userEmail
    // const docRef = doc(db, "your_collection", "your_document_id");
    // Add new elements to the 'items' array
    // await updateDoc(docRef, {
    // items: arrayUnion("new_item_1", "new_item_2")
    //});
    const connectionRefArrayID = userConnectionsRefArray[0];
    const docRef = doc(db, "userProfiles", connectionRefArrayID);
    await updateDoc(docRef, {
      userConnections: arrayUnion(userEmail),
    });

    //Second: delete the connectionsRequest document for the accepted user
    // this proceeds exactly like the delete button process
    console.log(" this thisUserEmail = ", requestToEmail);
    let connectionsID = 0;
    let refID = 0;
    //Loop through the connectionsRequests
    console.log("outside loop and connectionsID = ", connectionsID);
    console.log(
      " connectionRequestsAll.length = ",
      connectionRequestsAll.length
    );
    for (let i = 0, connectionsID = 0; i < connectionRequestsAll.length; i++) {
      if (
        connectionRequestsAll[i].requestFromEmail === userEmail &&
        connectionRequestsAll[i].requestToEmail === requestToEmail
      ) {
        connectionsID = i;
        refID = connectionsRefArray[connectionsID];
        console.log("in loop and connectionsID = ", connectionsID);
        console.log("refID = ", refID);
      }
    }

    await deleteDoc(doc(db, "connectionRequests", refID));
    setTimeout(reloadFromError, 2000);
  }

  async function deleteButtonFunction(userEmail) {
    console.log("in delete button function");
    //We've got the userEmail to delete and we have the connectionsArray and connectionsRefArray
    //Now, we need to establish the particular entry in the connectionsArray that has
    //userEmail as the requestFromEmail and has thisUserEmail as the requestToEmail. This has to
    //be done in a loop where we track the index and that index value will be used as the entry
    //index into the connectionsRefArray and that will be the reference of the doc to delete
    //connectionRequestsAll[] is the entire connectionRequestsAll array to search
    //connectionsRefArray[] is the entire array of connectionRequestsAll ids
    //connectionsID = connectionsRefArray[x] where x is the index number
    //To get the actual reference to delete we need:
    //const docRef = doc(db, "connectionRequests", connectionsID);

    //let thisUserEmail = "";
    //if (thisUserProfile.length != 0) {
    //  thisUserEmail = thisUserProfile.userEmail;
    //}
    console.log(" this thisUserEmail = ", requestToEmail);
    //setConnectButtonDisabled(true);
    //const firestore = getFirestore(app);
    //Note that the following is a reference to a collection
    //const ConnectionRequestsCollection = collection(
    //  firestore,
    //  "connectionRequests"
    //);
    //const myDocumentData = {
    //  requestFromEmail: userEmail,
    //  requestToEmail: thisUserEmail,
    //};

    //Query all connectionRequests
    //const qConnectionRequests = query(
    //  collection(db, "connectionRequests"),
    //  where("requestFromEmail", "==", userEmail),
    //  where("requestToEmail", "==", thisUserEmail)
    //orderBy("userProfileName", "desc")
    //);

    //connectionsID = connectionsRefArray[x] where x is the index number
    let connectionsID = 0;
    let refID = 0;
    //Loop through the connectionsRequests
    console.log("outside loop and connectionsID = ", connectionsID);
    console.log(
      " connectionRequestsAll.length = ",
      connectionRequestsAll.length
    );
    for (let i = 0, connectionsID = 0; i < connectionRequestsAll.length; i++) {
      if (
        connectionRequestsAll[i].requestFromEmail === userEmail &&
        connectionRequestsAll[i].requestToEmail === requestToEmail
      ) {
        connectionsID = i;
        refID = connectionsRefArray[connectionsID];
        console.log("in loop and connectionsID = ", connectionsID);
        console.log("refID = ", refID);
      }
    }

    await deleteDoc(doc(db, "connectionRequests", refID));
    setTimeout(reloadFromError, 2000);
    //console.log(" New document added with id: ", newDocRef.id);

    //console.log("before getDoc and id = ", newDocRef.id);
    //console.log("before getDoc and docRef = ", newDocRef);
    //if (newDocRef.id !== undefined) {
    //  console.log("newDocRef = ", newDocRef);
    //  //setTimeout(UpdateGroupID, 2000, newDocRef.id, newDocRef);
    //}
  }

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.top}>
          <h1 className={styles.header}>User Profile</h1>
          <button
            style={{ marginLeft: -150 }}
            className={styles.userButtons}
            onClick={() => acceptButtonFunction(userEmail)}
          >
            Accept
          </button>

          <button
            id="deleteButtonID"
            style={{ marginLeft: 90 }}
            className={styles.userButtons}
            onClick={() => deleteButtonFunction(userEmail)}
          >
            Delete
          </button>
          <button
            style={{ marginLeft: 90 }}
            className={styles.userButtons}
            onClick={() => history.back()}
          >
            Return
          </button>
        </div>
        <div>
          <label className={styles.userLabel}>First Name</label>
          <input
            type="text"
            readOnly
            style={{ paddingLeft: 3, marginLeft: 10 }}
            defaultValue={userFirstName}
          />
          <div>
            <label className={styles.userLabel}>Last Name</label>
            <input
              type="text"
              readOnly
              style={{ paddingLeft: 3, marginLeft: 12 }}
              defaultValue={userLastName}
            />
          </div>
          <div>
            <label className={styles.userLabel}>Profile Name</label>
            <input
              type="text"
              readOnly
              style={{ paddingLeft: 3, marginLeft: -3 }}
              defaultValue={userProfileName}
            />
          </div>
        </div>
        <div>
          <label className={styles.userLabel}>Country</label>
          <input
            type="text"
            readOnly
            style={{ paddingLeft: 3, marginLeft: 30 }}
            defaultValue={userCountry}
          />
        </div>
        <div>
          <label className={styles.userLabel}>Email</label>
          <input
            type="text"
            readOnly
            style={{ paddingLeft: 3, marginLeft: 43 }}
            defaultValue={userEmail}
          />
        </div>
        <div>
          <label className={styles.userLabel}>Photo</label>
          <img
            className={styles.userPhoto}
            src={userPhotoName}
            alt=""
            style={{
              paddingTop: 20,
              paddingLeft: 20,
              paddingRight: 20,
              height: 200,
              objectFit: "scale-down",
              marginLeft: 28,
            }}
          />
        </div>
        <br />
        <div className={styles.aimLabel}>
          <label>About...(useful for journals' "About the Author")</label>
          <textarea
            className={styles.messageText}
            style={{
              paddingLeft: 3,
              marginLeft: 30,
              width: 400,
              height: 170,
            }}
            defaultValue={userAbout}
          />
        </div>

        <div className={styles.userLabel}>
          <label>Profile Links</label>
          <input
            style={{
              paddingLeft: 3,
              width: 400,
              marginLeft: 273,
            }}
            type="text"
            defaultValue={userProfileLink1}
          />
          <a
            href={userProfile.userProfileLink1}
            target="_blank"
            style={{ display: "inline-grid" }}
          >
            <button className={styles.openButtons}>Open</button>
          </a>
        </div>

        <div className={styles.userLabel}>
          <input
            style={{
              paddingLeft: 3,
              width: 400,
              marginLeft: 360,
            }}
            type="text"
            defaultValue={userProfileLink2}
          />
          <a
            href={userProfile.userProfileLink2}
            target="_blank"
            style={{ display: "inline-grid" }}
          >
            <button className={styles.openButtons}>Open</button>
          </a>
        </div>

        <div className={styles.userLabel}>
          <input
            style={{
              paddingLeft: 3,
              width: 400,
              marginLeft: 360,
            }}
            type="text"
            defaultValue={userProfileLink3}
          />
          <a
            href={userProfileLink3}
            target="_blank"
            style={{ display: "inline-grid" }}
          >
            <button className={styles.openButtons}>Open</button>
          </a>
        </div>

        <div className={styles.userLabel}>
          <input
            style={{
              paddingLeft: 3,
              width: 400,
              marginLeft: 360,
            }}
            type="text"
            defaultValue={userProfileLink4}
          />
          <a
            href={userProfileLink4}
            target="_blank"
            style={{ display: "inline-grid" }}
          >
            <button className={styles.openButtons}>Open</button>
          </a>
        </div>
      </div>
    </>
  );
}

export default ToMeRequestsPost;
